import React, {useEffect} from 'react';
import FormTextArea from "../../layout/ui/FormTextArea";
import FormSelect from "../../layout/ui/FormSelect";
import {useNotifications} from "../../../providers/NotificationsProvider";
import {useApi} from "../../../providers/ApiProvider";
import ProjectsRequests from "../../../requests/ProjectsRequests";
import ProjectAccessTokensRequests from "../../../requests/ProjectAccessTokensRequests";
import FormTextField from "../../layout/ui/FormTextField";
import ButtonWithLoading from "../../layout/ui/ButtonWithLoading";
import FormCheckbox from "../../layout/ui/FormCheckbox";
import ProjectSharesRequests from "../../../requests/ProjectSharesRequests";
import {Link} from "react-router-dom";

export default function ProjectShareModalFeaturedManageAccess({onChange = () => {}, projectId = '', className = '', lastUpdate = 0}) {
    const notifications = useNotifications();
    const apiContext = useApi();
    const projectAccessTokensRequests = new ProjectAccessTokensRequests(apiContext.api, projectId);
    const projectSharesRequests = new ProjectSharesRequests(apiContext.api);

    const ACCESS_LEVEL_READ = 'read';
    const ACCESS_LEVEL_EDIT = 'edit';

    const [loading, setLoading] = React.useState([]);
    const [shareLoading, setShareLoading] = React.useState(null);
    const [accessTokens, setAccessTokens] = React.useState([]);
    const [projectShares, setProjectShares] = React.useState([]);



    useEffect(() => {
        getAccessTokens();
        getProjectShares();
    }, [lastUpdate]);


    const getAccessTokens = () => {
        let newLoading = [...loading];
        newLoading.push('access-tokens');
        setLoading(newLoading);

        projectAccessTokensRequests.list().then((response) => {
            if (response !== false) {
                setAccessTokens(response);
            }
        }).finally(() => {
            let newLoading = [...loading];
            newLoading = newLoading.filter(item => item !== 'access-tokens');
            setLoading(newLoading);
        });
    }


    const getProjectShares = () => {
        let newLoading = [...loading];
        newLoading.push('project-shares');
        setLoading(newLoading);

        projectSharesRequests.listForProject(projectId).then((response) => {
            if (response !== false) {
                setProjectShares(response);
            }
        }).finally(() => {
            let newLoading = [...loading];
            newLoading = newLoading.filter(item => item !== 'project-shares');
            setLoading(newLoading);
        });
    }


    const onRemoveAccessClick = (shareId) => {
        setShareLoading('remove-'+shareId);

        projectSharesRequests.delete(shareId).then((response) => {
            if (response !== false) {
                notifications.notify('Access removed successfully.', 'success');
                getProjectShares();
            } else {
                notifications.notify('Error removing access.', 'error');
            }
        }).finally(() => {
            setShareLoading(null);
        });
    }


    const changeAccessLevel = (shareId, accessLevel) => {
        projectSharesRequests.update(shareId, {level: accessLevel}).then((response) => {
            if (response !== false) {
                notifications.notify('Access changed successfully.', 'success');
                getProjectShares();
            } else {
                notifications.notify('Error changing access.', 'error');
            }
        }).finally(() => {
            setShareLoading(null);
        });
    }


    const formatDate = (date) => {
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        const dateObj = new Date(date);
        return dateObj.toLocaleDateString('en-UK', options);
    }


    const changeTokenAccessLevel = (accessTokenId, accessLevel) => {
        projectAccessTokensRequests.update(accessTokenId, {access_level: accessLevel}).then((response) => {
            if (response !== false) {
                notifications.notify('Access level updated successfully.', 'success');
                getAccessTokens();
            } else {
                notifications.notify('Error updating access level.', 'error');
            }
        }).finally(() => {
            setShareLoading(null);
        });
    }


    const onRemoveTokenAccessClick = (accessTokenId) => {
        setShareLoading('remove-token-'+accessTokenId);

        projectAccessTokensRequests.delete(accessTokenId).then((response) => {
            if (response !== false) {
                notifications.notify('Access removed successfully.', 'success');
                getAccessTokens();
            } else {
                notifications.notify('Error removing access.', 'error');
            }
        }).finally(() => {
            setShareLoading(null);
        });
    }


    return (
        <div className={className + ''}>
            <h4 className="fs-4 fw-semibold">Manage access</h4>

            {projectShares && projectShares.length ? (
                <div className="mb-4">
                    {projectShares.map((share, index) => {
                        if (!share.invited) {return '';}

                        return (
                        <div key={index} className="d-flex justify-content-between align-items-center mb-2">
                            <div>
                                <div>{share.invited.name}</div>
                                <div className="fs-1 text-muted">{share.invited.email}</div>
                            </div>
                            <div className="d-flex justify-content-end align-items-center gap-3">
                                <div style={{width: '200px'}}>
                                    <FormSelect
                                        label={false}
                                        value={share.level}
                                        options={[
                                            {value: ACCESS_LEVEL_READ, label: 'Can View'},
                                            {value: ACCESS_LEVEL_EDIT, label: 'Can Edit'},
                                        ]}
                                        onChange={(value) => changeAccessLevel(share.id, value)}
                                        groupClassName=""
                                    />
                                </div>

                                <div key={index} className="d-flex justify-content-between align-items-center gap-2">
                                    <ButtonWithLoading
                                        className="btn-circle btn-light btn-sm justify-content-center"
                                        iconClassName="ti ti-x fs-3"
                                        noOriginalIconClassName={true}
                                        loading={shareLoading === 'remove-'+share.id}
                                        spinnerClassName="spinner-border spinner-border-sm"
                                        noOriginalSpinnerClassName={true}
                                        onClick={() => {
                                            onRemoveAccessClick(share.id)
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    )})}
                </div>
            ) : null}

            {accessTokens && accessTokens.length ? (
                <div className="mb-4">
                    {accessTokens.map((accessToken, index) => {
                        let url = window.location.origin + '/p/' + projectId + '/a/' + accessToken.id;
                        let urlLabel = window.location.origin + '/...';
                        urlLabel += accessToken.id.slice(-7);

                        return (
                        <div key={index} className="d-flex justify-content-between align-items-start mb-2 gap-3">
                            <div>
                                <div className="d-flex align-items-center gap-3">
                                    <Link to={url}>{urlLabel}</Link>

                                    <button
                                        className="btn btn-sm btn-icon btn-light-primary text-primary"
                                        onClick={() => {
                                            navigator.clipboard.writeText(url).then(() => {
                                                //console.log('Text copied to clipboard');
                                                notifications.notify('Link copied to clipboard', 'success');
                                            })/*.catch(err => {
                                                //console.error('Failed to copy text:', err);
                                            })*/;
                                        }}
                                    >
                                        <i className="ti ti-copy fs-2"></i>
                                    </button>
                                </div>
                                <div className="fs-1 text-muted mt-n1">Last changed {formatDate(accessToken.updated_at)}</div>
                                {accessToken.notes ? (<div className="fs-2 text-dark mt-1">{accessToken.notes}</div>) : null}
                            </div>
                            <div className="d-flex justify-content-end align-items-center gap-3">
                                <div style={{width: '200px'}}>
                                    <FormSelect
                                        label={false}
                                        value={accessToken.access_level}
                                        options={[
                                            {value: ACCESS_LEVEL_READ, label: 'Can View'},
                                            {value: ACCESS_LEVEL_EDIT, label: 'Can Edit'},
                                        ]}
                                        onChange={(value) => changeTokenAccessLevel(accessToken.id, value)}
                                        groupClassName=""
                                    />
                                </div>

                                <div key={index} className="d-flex justify-content-between align-items-center gap-2">
                                    <ButtonWithLoading
                                        className="btn-circle btn-light btn-sm justify-content-center"
                                        iconClassName="ti ti-x fs-3"
                                        noOriginalIconClassName={true}
                                        loading={shareLoading === 'remove-token-'+accessToken.id}
                                        spinnerClassName="spinner-border spinner-border-sm"
                                        noOriginalSpinnerClassName={true}
                                        onClick={() => {
                                            onRemoveTokenAccessClick(accessToken.id)
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    )})}
                </div>
            ) : null}


            {(!accessTokens || accessTokens.length === 0) && (!projectShares || projectShares.length === 0) ? (<div className="text-muted fs-2">Nothing shared at the moment.</div>) : null}
        </div>
    );
}
